//
//  intro.ts
//  moods-film-ui-master
//
//  Created by romainharvier@gmail.com on 10/08/2019.
//  Copyright © 2019 Moods. All rights reserved.
//

import {Vue, Component, Prop} from 'vue-property-decorator';
import lottie from 'lottie-web';

@Component
export default class Intro extends Vue {

    @Prop(String) private readonly context!: string;

    private mounted(): void {

        this.handleLottieScrollAnimation('scrollArrow_1');
        this.handleLottieScrollAnimation('scrollArrow_2');

    }

    /*
     * Load the scroll arrow down animation with lottie.
     */
    private handleLottieScrollAnimation(ref: string): void {

        lottie.loadAnimation({
            container: this.$refs[ref] as HTMLElement, // the dom element that will contain the animation
            renderer: 'svg',
            loop: true,
            autoplay: true,
            path: '/image/lottie/scroll-arrow.json', // the path to the animation json
        });

    }

}
